import {
  LIST_REVIEW_SINGLE,
  RESET_STATE_REVIEW_SINGLE,
} from "../../Types";

const initialState ={
  listReview: []
}
export const reviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_REVIEW_SINGLE: {
      return {
        ...state,
        listReview: action.payload,
      };
    }
    case RESET_STATE_REVIEW_SINGLE:
      return initialState;
    default:
      return state;
  }
};
